/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
export var TooltipWrapper = function (_a) {
    var target = _a.target, content = _a.content, _b = _a.placement, placement = _b === void 0 ? 'bottom' : _b;
    return (React.createElement(UncontrolledTooltip, { placement: placement, target: target, autohide: true, className: "border-radius-0" }, content));
};
